import { PageHeader } from '@/components/PageHeader';
import { SecurityComplianceManager } from '@/components/SecurityComplianceManager';
import { ProductionSecurityCompliance } from '@/components/ProductionSecurityCompliance';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export default function SecurityCompliance() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Security & Compliance"
        description="Manage security policies, compliance frameworks, and data protection"
      />
      
      <Tabs defaultValue="management" className="space-y-6">
        <TabsList>
          <TabsTrigger value="management">Security Management</TabsTrigger>
          <TabsTrigger value="compliance">Compliance Dashboard</TabsTrigger>
        </TabsList>
        
        <TabsContent value="management">
          <SecurityComplianceManager />
        </TabsContent>
        
        <TabsContent value="compliance">
          <ProductionSecurityCompliance />
        </TabsContent>
      </Tabs>
    </div>
  );
}